import { Label, Switch } from "@ui/shad"
import { cn } from "@ui/utils"

interface SwitchInputProps {
  id: string
  checked?: boolean
  onChange?: (checked: boolean) => void
  label?: string
  error?: boolean
  disabled?: boolean
  helperText?: string
}

export function SwitchInput({
  id,
  checked = false,
  onChange,
  label,
  error,
  disabled = false,
  helperText,
}: SwitchInputProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center">
        <div className="mr-2 space-y-0.5">
          {label && (
            <Label htmlFor={id} className={cn(error && "text-destructive")}>
              {label}
            </Label>
          )}
        </div>
        <Switch id={id} checked={checked} onCheckedChange={onChange} disabled={disabled} />
      </div>
      {helperText && <p className="text-muted-foreground text-xs">{helperText}</p>}
    </div>
  )
}
